import { render } from "./TpProximosWidget.vue?vue&type=template&id=4c062172&scoped=true"
import script from "./TpProximosWidget.vue?vue&type=script&lang=js"
export * from "./TpProximosWidget.vue?vue&type=script&lang=js"

import "./TpProximosWidget.vue?vue&type=style&index=0&id=4c062172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c062172"]])

export default __exports__